/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateRewardLogDto } from '../../models/create-reward-log-dto';
import { RewardLog } from '../../models/reward-log';

export interface RewardLogsControllerCreate$Params {
      body: CreateRewardLogDto
}

export function rewardLogsControllerCreate(http: HttpClient, rootUrl: string, params: RewardLogsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<RewardLog>> {
  const rb = new RequestBuilder(rootUrl, rewardLogsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RewardLog>;
    })
  );
}

rewardLogsControllerCreate.PATH = '/reward-logs';
